import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Widget, CreateTransformDto } from '../_models/widget';

@Injectable({
  providedIn: 'root'
})
export class WidgetServiceService {

  // base address returned from environment does not include "api/widget";
  // append the controller route so callers don't need to remember it.
  private readonly baseUrl = `${environment.widgetsApiUrl}api/widget`;

  constructor(private _http: HttpClient) { }

  /** retrieves all widgets */
  getAll(): Observable<Widget[]> {
    return this._http.get<Widget[]>(`${this.baseUrl}`);
  }

  /** retrieve a single widget by its numeric id */
  getById(id: number): Observable<Widget> {
    return this._http.get<Widget>(`${this.baseUrl}/${id}`);
  }

  /** create a new widget */
  create(widget: Widget): Observable<Widget> {
    return this._http.post<Widget>(`${this.baseUrl}`, widget);
  }

  /** update an existing widget */
  update(id: number, widget: Widget): Observable<Widget> {
    return this._http.put<Widget>(`${this.baseUrl}/${id}`, widget);
  }

  /** get all widgets for a specific application id */
  getByApplication(applicationId: string): Observable<Widget[]> {
    return this._http.get<Widget[]>(`${this.baseUrl}/application/${applicationId}`);
  }

  /** call transform endpoint (html/xml) */
  transform(id: number, payload: CreateTransformDto): Observable<string> {
    return this._http.patch<string>(`${this.baseUrl}/${id}/tranform`, payload);
  }

  /** delete a widget (controller currently has no DELETE action, added for future) */
  delete(id: number): Observable<any> {
    return this._http.delete(`${this.baseUrl}/${id}`);
  }
}
